const registrationMixin = {
  methods: {
    updateNext () {
      if (!this.syncKeys) {
        return this.$emit('nextStep', {
          user: this.user || undefined
        })
      }

      const object = Object.keys(this.syncKeys).reduce((acc, key) => ({ ...acc, [key]: this[this.syncKeys[key]] }), {})
      this.$emit('nextStep', object)
    }
  },

  computed: {
    steps () { return this.$store.state.registration.steps },
    currentStepIndex () { return this.steps.findIndex(route => `register-${route}` === this.$route.name) }
  }
}

export default registrationMixin
